module.exports = __webpack_public_path__ + "media/images/lavita_banner/composed_banner/banner__sponsor__text__right-b7ac633b5a06e781f33c148e0bfc6f72.png";